<template>
  <section class="Haut">
    <header class="Fiche__header text-reg text-moyen">
      <div class="tl block">
        <span class="text-moyen" v-if="p.surfaces.length > 0"
          >&thinsp;{{
            formatNumbers(getBiggestSurface(p).content)
          }}&thinsp;m²</span
        >
      </div>
      <div class="tc block">
        <span class="text-moyen">{{
          mapNames(p.typologies).replace(" – ", "\u00a0-\u00a0")
        }}</span>
      </div>
      <div class="tr block">
        <div v-if="date" class="text-moyen">
          <span class="text-light">{{ date.text }}</span
          >&nbsp;<span v-html="formatDateFrench(date.content)"></span>
        </div>
      </div>
    </header>
  </section>
</template>

<script>
import {
  formatNumbers,
  formatNumbersFrench,
  formatDate,
  formatDateFrench,
  getDate,
  mapNames,
  getBiggestSurface,
  getLatestDate
} from "../../../../../util/func";

export default {
  name: "haut-fiche",
  props: {
    p: {},
    pm: {}
  },
  methods: {
    formatNumbers,
    formatNumbersFrench,
    formatDate,
    getDate,
    mapNames,
    getBiggestSurface,
    formatDateFrench
  },
  computed: {
    date() {
      return getLatestDate(this.p);
    }
  }
};
</script>
